import { isValidBridgeSubscription } from 'lib/client/api/bridge-validation'
import useSWR from 'swr'

const useBridgeProfileValidation = () => {
  const { data, error, isLoading } = useSWR('/bridge/profile-validation', isValidBridgeSubscription, {
    refreshInterval: 60 * 1000 * 15 // 15 minutes
  })

  return {
    data,
    error,
    isLoading
  }
}

export default useBridgeProfileValidation
